import tw from "twin.macro";

export const SectionHeading = tw.h2`text-2xl md:text-4xl sm:text-xl font-black tracking-wide text-center`
export const Subheading = tw.h5`font-bold text-primary-500`
